import * as React from 'react';

import Form from './Form';
import HistoryRowData from './HistoryRowData';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistoryRow from 'Components/HistoryRow';
import FormEditingHandler from 'Containers/FormEditingHandler';
import HistoryRowControls from 'Components/HistoryRowControls';

import { sortPartialDate } from 'neuro-utils';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';

const DEFAULT_DOCUMENTS: IOwnProps['documents'] = [];

const GeneTest = ({ documents = DEFAULT_DOCUMENTS, name }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="geneTest" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="geneTest"
            headerId={'geneTest.title'}
            editing={editing}
            editButtons={
              <div>
                <DocumentCreationButton name={name} text={'general.new'} onClick={startEdit({})} />
              </div>
            }
          />
          {!editing && documents
            ? documents
                .toSorted((n1, n2) => sortPartialDate(n2.date, n1.date))
                .map(d => (
                  <HistoryRow
                    headerText={d.date ? formatPartialDate(d.date) : undefined}
                    key={d._id}
                    rowButton={<HistoryRowControls document={d} startEdit={startEdit} />}
                    controlsMargin={false}
                  >
                    <HistoryRowData d={d} />
                  </HistoryRow>
                ))
            : undefined}
          {editing ? <Form formData={formData} editing={editing} /> : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents?: IDocumentWithTypeV2<'geneTest'>[];
  name: string;
}

export default GeneTest;
